import { SHOP_DOCUMENT_STATUSES } from '../../constants/shopDocumentStatuses'

export default function DocumentStatus({ status }) {
  const documentStatus = SHOP_DOCUMENT_STATUSES[status]
  if (!documentStatus) {
    return
  }

  return (
    <span className={`px-2 py-1 text-xs font-medium rounded-full border ${documentStatus.color}`}>
      {documentStatus?.label}
    </span>
  )
}
